/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import parse from 'html-react-parser'
import SharedLayout from '../components/shared-layout'
import Chat from '../components/svgs/Chat'
import Clock from '../components/svgs/Clock'
import Eye from '../components/svgs/Eye'
import Facebook from '../components/svgs/Facebook'
import Twitter from '../components/svgs/Twitter'
import Pinterest from '../components/svgs/Pinterest'
import Messenger from '../components/svgs/Messenger'
import RelatedPosts from '../components/related-posts'
import PostNavigation from '../components/button/PostNavigation'
import * as styles from './BlogView.module.scss'
import SEO from '../components/seo'

function formatDate(isoDateString) {
  const date = new Date(isoDateString)
  const now = new Date()

  const diffMilliseconds = now - date
  const diffSeconds = Math.floor(diffMilliseconds / 1000)
  const diffMinutes = Math.floor(diffSeconds / 60)
  const diffHours = Math.floor(diffMinutes / 60)
  const diffDays = Math.floor(diffHours / 24)
  const diffMonths = Math.floor(diffDays / 30)
  const diffYears = Math.floor(diffDays / 365)

  if (diffSeconds < 60) {
    return `${diffSeconds} seconds ago`
  } else if (diffMinutes < 60) {
    return `${diffMinutes} minutes ago`
  } else if (diffHours < 24) {
    return `${diffHours} hours ago`
  } else if (diffDays < 30) {
    return `${diffDays} days ago`
  } else if (diffMonths < 12) {
    return `${diffMonths} months ago`
  } else {
    return `${diffYears} years ago`
  }
}

const readingTimes = {};

function BlogView({ data }) {
  let { blogs } = data.data

  const previousPost = data.previousPost || null
  const nextPost = data.nextPost || null
  blogs = blogs.map((blog) => {
    const description = blog.blogDescription
    const readingTimeRegex = /<span class="rt-label rt-prefix">([^<]*)<\/span>\s*<span class="rt-time">([^<]*)<\/span>\s*<span class="rt-label rt-postfix">([^<]*)<\/span>/g
    const readingTimeMatch = readingTimeRegex.exec(description)
    let readingTime = ''
    if (readingTimeMatch && readingTimeMatch.length > 1) {
      readingTime = readingTimeMatch[2].replace(/<[^>]+>/g, '')
    }
    const excerpt = blog.excerpt
    const excerptReadingTimeRegex =
      /<span class="rt-reading-time"([^>]*)>(.*)<\/span>/g
    const excerptReadingTimeMatch = excerptReadingTimeRegex.exec(excerpt)
    let excerptReadingTime = ''
    if (excerptReadingTimeMatch && excerptReadingTimeMatch.length > 1) {
      excerptReadingTime = excerptReadingTimeMatch[2].replace(/<[^>]+>/g, '')
    }
    const combinedReadingTime = readingTime || excerptReadingTime

    if( combinedReadingTime !== '' ){
      readingTimes[blog.id] = combinedReadingTime;
    }
    const descriptionWithoutReadingTime = description.replace(
      readingTimeRegex,
      '',
    )
    const excerptWithoutReadingTime = excerpt.replace(
      excerptReadingTimeRegex,
      '',
    )
  
    blog.blogDescription = descriptionWithoutReadingTime
    blog.excerpt = excerptWithoutReadingTime
    blog.readingTime = readingTimes[blog.id]
  
    return blog
  })
  let relatedPosts = data.relatedPosts.nodes

  relatedPosts = data.relatedPosts.nodes.map((blog) => {
    const excerptReadingTimeRegex =
    /<span class="rt-label rt-prefix">([^<]*)<\/span>\s*<span class="rt-time">([^<]*)<\/span>\s*<span class="rt-label rt-postfix">([^<]*)<\/span>/g
    const excerptReadingTimeMatch = excerptReadingTimeRegex.exec(blog.excerpt)
    let excerptReadingTime = ''
    if (excerptReadingTimeMatch && excerptReadingTimeMatch.length > 1) {
      excerptReadingTime = excerptReadingTimeMatch[2].replace(/<[^>]+>/g, '')
    }

    const readingTimeInMinutes = excerptReadingTime
    blog.readingTime = readingTimeInMinutes
    delete blog.excerpt
    return blog
  })

  return (
    <SharedLayout>
      <div className={`projectContainer ${styles.blogViewMainContainer}`}>
        <div className={`${styles.imgContainer}`}>
          {blogs[0].blogCoverImage.node.sourceUrl ? (
            <img
              className={`${styles.viewImg}`}
              src={blogs[0].blogCoverImage.node.sourceUrl}
              alt={blogs[0].blogTitle}
            />
          ) : null}
          {/* {blogs[0].blogDescription ? (
            <p className={`${styles.imgText}`}>{blogs[0].blogDescription}</p>
          ) : null} */}
        </div>
        <div
          className={`d-flex flex-column flex-md-row ${styles.contentContainer}`}
        >
          <div
            className={`order-1 order-md-0 d-flex flex-md-column ${styles.socialContainer}`}
          >
            <div className="d-flex align-items-center justify-content-center">
              <a
                href={`https://twitter.com/share?url=${process.env.GATSBY_APP_URL}/blog/${blogs[0].slug}`}
                target="_blank"
                rel="noreferrer"
                className={`${styles.socialLink}`}
              >
                <Twitter className={`${styles.socialIcon}`} />
              </a>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <a
                href={` https://facebook.com/sharer/sharer.php?u=${process.env.GATSBY_APP_URL}/blog/${blogs[0].slug}`}
                target="_blank"
                rel="noreferrer"
                className={`${styles.socialLink}`}
              >
                <Facebook className={`${styles.socialIcon}`} />
              </a>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <a
                href={`https://pinterest.com/pin/create/bookmarklet/?&url=${process.env.GATSBY_APP_URL}/blog/${blogs[0].slug}`}
                target="_blank"
                rel="noreferrer"
                className={`${styles.socialLink}`}
              >
                <Pinterest className={`${styles.socialIcon}`} />
              </a>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <a
                href={`fb-messenger://share?link=${process.env.GATSBY_APP_URL}/blog/${blogs[0].slug}`}
                target="_blank"
                rel="noreferrer"
                className={`${styles.socialLink}`}
              >
                <Messenger className={`${styles.socialIcon}`} />
              </a>
            </div>
          </div>
          <div className={`order-0 order-md-1 ${styles.blogContent}`}>
            <div
              className={`d-flex align-items-center ${styles.blogLinkContainer}`}
            >
              {blogs[0].blogCategories.nodes
                ? blogs[0].blogCategories.nodes.map((category, index) => (
                    <Link
                      className={`${styles.categoryLink}`}
                      key={index}
                      to={`/blog/category/${category.slug}`}
                    >
                      {index < blogs[0].blogCategories.nodes.length && index > 0
                        ? ', '
                        : null}
                      {category.name.toUpperCase()}
                    </Link>
                  ))
                : null}
            </div>
            <div className={`${styles.blogContentTitle}`}>
              <p>{blogs[0].blogTitle}</p>
            </div>
            <div
              className={`d-flex align-items-center ${styles.titleDecContainer}`}
            >
              <div className={`d-flex align-items-center ${styles.decChild}`}>
                {blogs[0].blogAuthor && blogs[0].blogAuthor.node ? (
                  <div
                    className={`d-flex align-items-center ${styles.childImgMainContainer}`}
                  >
                    <div className={`${styles.childImg}`}>
                      <img
                        className={`${styles.blogImg}`}
                        src={blogs[0].blogAuthor.node.avatar.url}
                        alt={blogs[0].blogAuthor.node.name}
                      />
                    </div>
                    <div className={`${styles.imgName}`}>
                      {blogs[0].blogAuthor.node.name}
                    </div>
                  </div>
                ) : null}
                {formatDate(blogs[0].blogPublishDate) ? (
                  <div className={`${styles.blogDate}`}>
                    ,{formatDate(blogs[0].blogPublishDate)}
                  </div>
                ) : null}
              </div>
              <div className={`d-flex align-items-center ${styles.decChild}`}>
                <div className={`${styles.childImgContainer}`}>
                  <Chat className={`${styles.childImgIcon}`} /> 0
                </div>
                <div className={`${styles.childImgContainer}`}>
                  <Clock className={`${styles.childImgIcon}`} />{' '}
                  {blogs[0].readingTime} mins
                </div>
                <div className={`${styles.childImgContainer}`}>
                  <Eye className={`${styles.childImgIcon}`} />
                  2241
                </div>
              </div>
            </div>
            <div className={`${styles.blogHtml}`}>
              {parse(blogs?.[0]?.blogDescription)}
            </div>
            {blogs[0].blogTags && blogs[0].blogTags.nodes.length > 0 ? (
              <div className={`${styles.blogHtmlTagContainer}`}>
                <p>#Tags</p>
                {blogs[0].blogTags.nodes.map((tag) => (
                  <Link
                    className={`${styles.blogHtmlTagLink}`}
                    key={tag.name}
                    to={`/blog/tag/${tag.name}`}
                  >
                    #{tag.name}
                  </Link>
                ))}
              </div>
            ) : null}
          </div>
        </div>
        <div
          className={`d-xl-flex justify-content-xl-between ${styles.navigationMainContainer}`}
        >
          {previousPost && previousPost.nodes[0] ? (
            <PostNavigation
              link={previousPost.nodes[0].slug}
              imageSrc={previousPost.nodes[0].blogCoverImage.node.sourceUrl}
              title={previousPost.nodes[0].blogTitle}
              categories={previousPost.nodes[0].blogCategories.nodes.map((category) => ({
                name: category.name,
                slug: category.slug,
              }))}
              buttonLeft
            />
          ) : null}

          {nextPost && nextPost.nodes[0]? (
            <PostNavigation
              link={nextPost.nodes[0].slug}
              imageSrc={nextPost.nodes[0].blogCoverImage.node.sourceUrl}
              title={nextPost.nodes[0].blogTitle}
              categories={nextPost.nodes[0].blogCategories.nodes.map((category) => ({
                name: category.name,
                slug: category.slug,
              }))}
              buttonRight
            />
          ) : null}
        </div>

        <RelatedPosts data={relatedPosts} />
      </div>
    </SharedLayout>
  )
}

BlogView.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
}

export default BlogView

export const pageQuery = graphql`
  query BlogListQuery(
    $id: String!
    $previousPostId: String = null
    $nextPostId: String = null
    $categories: [String]!
    $prevFlag: Boolean!
    $nextFlag: Boolean!
  ) {
    data: allWpPost(filter: { id: { eq: $id } }) {
      blogs: nodes {
        id
        slug
        blogAuthor: author {
          node {
            name
            avatar {
              url
            }
          }
        }
        blogCategories: categories {
          nodes {
            name
            slug
          }
        }
        blogCoverImage: featuredImage {
          node {
            sourceUrl
          }
        }
        blogTags: tags {
          nodes {
            name
          }
        }
        blogTitle: title
        blogDescription: content
        blogPublishDate: date
        excerpt: excerpt
        seo {
          metaDesc
          metaKeywords
          title
          opengraphTitle
          opengraphDescription
          readingTime
        }
      }
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemCount
        pageCount
        perPage
        totalCount
      }
    }
    relatedPosts: allWpPost(
      filter: {
        categories: { nodes: { elemMatch: { name: { in: $categories } } } }
      }
    ) {
      nodes {
        excerpt: excerpt
        id
        slug
        blogAuthor: author {
          node {
            name
            avatar {
              url
            }
          }
        }
        blogCoverImage: featuredImage {
          node {
            sourceUrl
          }
        }
        blogTitle: title
        blogPublishDate: date
        blogCategories: categories {
          nodes {
            name
            slug
          }
        }
      }
    }
    previousPost: allWpPost(filter: { id: { eq: $previousPostId } })
      @include(if: $prevFlag) {
      nodes {
        slug
        blogCoverImage: featuredImage {
          node {
            sourceUrl
          }
        }
        blogTitle: title
        blogCategories: categories {
          nodes {
            name
            slug
          }
        }
      }
    }
    nextPost: allWpPost(filter: { id: { eq: $nextPostId } })
      @include(if: $nextFlag) {
      nodes {
        slug
        blogCoverImage: featuredImage {
          node {
            sourceUrl
          }
        }
        blogTitle: title
        blogCategories: categories {
          nodes {
            name
            slug
          }
        }
      }
    }
  }
`

export const Head = ({ pageContext: { language }, data }) => {
  if (data && data.data && data.data.blogs && data.data.blogs.length > 0) {
    const blog = data.data.blogs[0];
    if (blog.seo) {
      return (
        <SEO
          data={blog.seo}
          lang={language}
          ogTitle={blog.seo.opengraphTitle}
          description={blog.seo.metaDesc}
          ogDescription={blog.seo.opengraphDescription}
          metaTitle={blog.seo.title}
          keywords={blog.seo.metaKeywords}
          pageTitle={blog.seo.title}
          fromBlogView={true}
          articlePublisher="https://www.facebook.com/sifars.tech"
          articlePublishedTime={blog.blogPublishDate}
          articleModifiedTime={blog.blogPublishDate}
          twitterCard="summary_large_image"
          twitterSite="@sifars"
          ogImage={blog.blogCoverImage.node.sourceUrl}
          ogImageWidth="1280"
          ogImageHeight="720"
          twitterCreator="@sifars1"
          twitterLabel1="Written by"
          twitterData1={blog.blogAuthor.node.name}
          twitterLabel2="Est. reading time"
          twitterData2={blog.seo.readingTime + " minutes"}
        />
      );
    }
  }
  return null;
};


